import {PaymentMethodProps} from 'modules/payment-methods/types';
import React from 'react';
import {FiCreditCard} from 'react-icons/fi';
import Column from 'shared/components/column';
import Row from 'shared/components/row';
import {RegularText} from 'shared/components/text';
import toBrl from 'shared/util/to-brl';
import pix from 'shared/assets/images/pix.png';

const Payment: React.FC<PaymentMethodProps> = ({name, change, pixChange}) => {
  const getIcon = () => {
    if (name === 'Pix')
      return (
        <img src={pix} style={{width: 20, height: 20, objectFit: 'contain'}} />
      );

    if (name === 'Cartão de crédito ou débito')
      return <FiCreditCard size={16} color="black" />;
  };

  return (
    <Column>
      <Row gap={10}>
        <Column>
          <Row gap={5}>
            {getIcon()}
            <RegularText>{name}</RegularText>
          </Row>
          {change && <RegularText>Troco para {toBrl(change)}</RegularText>}
          {pixChange && <RegularText>Troco via pix: {pixChange}</RegularText>}
        </Column>
      </Row>
    </Column>
  );
};

export default Payment;
